import { type Nullable } from '@libs/core';
import { type DiscountDetails } from '@libs/common-types';
import { client } from '../../client';
import { CWEA_ENDPOINTS } from '../../constants';

export async function getDiscountDetails(key: string): Promise<Nullable<DiscountDetails>> {
    const url = CWEA_ENDPOINTS.discounts.getDiscountDetails(key);
    return (
        (await client.cwea<DiscountDetails | null>(url, {
            cache: 'no-store',
            withLocale: true,
        })) ?? null
    );
}
